<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent-fm5"><a id="page_viii"></a><a id="page_ix"></a>I am the last of the novelists for a long time now.</p>
<p class="noindent-fm6">There never was a good biography of a good novelist. There couldn’t be. He is too many people if he’s any good.</p>
<p class="noindent-fm6">Biography is the falsest of the arts. That is because there were no Keatzians before Keats, no Lincolnians before Lincoln.</p>
<p class="noindent-fm6">I left my capacity for hoping on the little roads that led to Zelda’s sanitarium.</p>
<p class="noindent-fm6">The voices fainter and fainter—How is Zelda, how is Zelda—tell us—how is Zelda.</p>
<p class="noindent-fm6">Genius is the ability to put into effect what is in your mind. There’s no other definition of it.</p>
<p class="noindent-fm6">I look out at it—and I think it is the most beautiful history in the world. It is the history of me and of my people. And if I came here yesterday like Sheilah I should still think so. It is the history of all aspiration—not just the American dream but the human dream and if I came at the end of it that too is a place in the line of pioneers.</p>
<p class="noindent-fm6">Then I was drunk for many years, and then I died.</p>
<p class="noindent-fm7">—From the <em class="italic">Notebooks</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Fm02.vue?058a3990